import Openable from './openable';

class Drawer extends Openable {
  constructor(element, overlay, context) {
    super(element, overlay, context);

    this.classes = {
      ...this.classes,
      active: 'drawer--active',
    };
  }
}

export default (element, overlay, context) => new Drawer(element, overlay, context);
